import gql from "graphql-tag";

export const MY_NEWS_SUBSCRIPTION = gql`
  subscription myNewsSubscription {
    myNewsSubscription
  }
`;
